// Which YAML template a matter is shown with: the id the server stamped,
// else its case type's own template, else its practice area's. Keys are
// the server's caseType values; the slug rows serve the fixtures.

import type { Matter } from "../../data/types";

const TEMPLATE_BY_AREA: Record<string, string> = {
  immigration: "immigration-general",
  ssi: "ssi",
  municipal: "municipal-court",
  wills: "estate-wills-probate",
  family: "family-law",
  pi: "personal-injury-auto",
  criminal: "criminal-defense",
  traffic: "traffic",
  dui: "dui",
  medmal: "medmal",
  civil: "civil-litigation",
  appeals: "appeals",
  bankruptcy: "bankruptcy",
};

// Only a type whose template differs from its area's default has a row.
const TEMPLATE_BY_SUBTYPE: Record<string, string> = {
  asylum: "immigration-asylum-defensive",
  withholding: "immigration-asylum-defensive",
  cat: "immigration-asylum-defensive",
  dui: "dui",
  // Fixture slugs.
  "removal-defense": "immigration-asylum-defensive",
  "family-petition": "immigration-family-petition",
};

export function resolveTemplateId(matter: Matter | null | undefined): string | null {
  if (!matter) return null;
  if (matter.practiceAreaTemplateId) return matter.practiceAreaTemplateId;
  const bySubtype = matter.subtype ? TEMPLATE_BY_SUBTYPE[matter.subtype] : undefined;
  return bySubtype ?? TEMPLATE_BY_AREA[matter.practiceArea] ?? null;
}
